import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { Checkbox } from '@telus-uds/components-web';

import StatusError from '@telus-uds/palette-allium/build/web/icons/StatusError';
import request from '../../utils/request';
import { sortedObjects } from '../../utils/utils';
import Label from './common/label';

const MultiProvince = ({ labels, errors, touched }) => {
  const [provinceList, setProvinceList] = useState([]);

  useEffect(() => {
    request.get('/provinces').then(({ data: { provinces } }) => {
      setProvinceList(provinces);
    });
  }, []);

  return (
    <>
      <Label labelName={labels.SELECT_PROVINCE} />
      <div
        style={{ position: 'relative', width: '100%' }}
        className={`frg-select-container color-light input-container ${
          errors.multiProvinces && touched.multiProvinces ? 'error' : ''
        }`}
      >
        <div role="group" aria-labelledby="checkbox-group">
          {provinceList &&
            provinceList.length > 0 &&
            sortedObjects(provinceList, 'name').map(province => {
              return (
                <div key={province.name}>
                  <Checkbox
                    label={province.name}
                    name="multiProvinces"
                    value={province.name}
                  />
                </div>
              );
            })}
        </div>
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.multiProvinces}</span>
          </div>
          <div id="multiProvinces_error_icon" className="error_messages_icon">
            <StatusError size={16} color="#C12335" aria-hidden="true" />
          </div>
        </>
      </div>
    </>
  );
};

MultiProvince.propTypes = {
  labels: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired
};

export default MultiProvince;
